import { render, staticRenderFns } from "./EditFaqComponent.vue?vue&type=template&id=2aa83afd&"
import script from "./EditFaqComponent.vue?vue&type=script&lang=js&"
export * from "./EditFaqComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports